/** @jsxImportSource @emotion/react */
"use client"; // error components must be Client Components

import Bugsnag from "@bugsnag/js";
import type { Interpolation } from "@emotion/react";
import {
  Button,
  numericPercentages,
  numericPixels,
  spacing,
  Text,
} from "@packages/ui";
import { useEffect } from "react";

const errorContainerStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: numericPixels[360],
  justifyContent: "center",
  maxHeight: numericPercentages[100],
};

const titleStyles: Interpolation = {
  marginBottom: spacing.xl,
};

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Bugsnag.notify(error);
  }, [error]);

  return (
    <div css={errorContainerStyles}>
      <Text size="m" type="headline" css={titleStyles}>
        Something went wrong!
      </Text>
      <Button
        // attempt to recover by trying to re-render the segment
        onClick={() => reset()}
      >
        Try again
      </Button>
    </div>
  );
}
